/**
 * Created by andrey on 22.04.2024
 */
const LoaderSceneBackground = cc.Node.extend({
    ctor: function (options) {
        this._super();

        this.bundleId = options.bundleId;
        this.onShowAgeRestriction = options.onShowAgeRestriction;

        this.setVisible(false);
        this.onResize();

        if (connector.platform.oneOf(connector.WECHAT)) {
            this.addDescription();
        }

        if (connector.platform.oneOf(connector.SAMSUNG, connector.WECHAT)) {
            this.addAgeRestriction();
        }
    },

    addBackground: function () {
        const background = this.background = new cleverapps.Spine(bundles[this.bundleId].jsons.background_json);
        background.setAnimation(0, "animation");
        this.addChild(background, -1);

        this.setVisible(true);
        cleverapps.resolution.showCanvas();

        this.addAnimations();
        this.onResize();

        this.triggerShowAgeRestriction();

        if (cc.game.isPaused()) {
            cc.game.step();
        }
    },

    addDescription: function () {
        const msg = "健康游戏忠告\n"
            + "抵制不良游戏,拒绝盗版游戏,注意自我保护,谨防受骗上当.\n"
            + "适度游戏益脑,沉迷游戏伤身,合理安排时间,享受健康生活.\n"
            + "批准文号：新广出审[2016]4509号 软著登记号：2016SR194719\n"
            + "著作权人：广州道泉网络科技有限公司 出版物号：ISBN 978-7-7979-3066-6\n"
            + "出版单位名称：广州盈正信息技术有限公司 运营单位：深圳彩苻科技有限公司";

        const description = this.description = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.LOADER_SCENE_DESCRIPTION);
        description.setAnchorPoint(0.5, 0.5);
        description.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        this.addChild(description);
    },

    addAgeRestriction: function () {
        if (cleverapps.isLocalhost()) {
            ageRestrictionSrc = "cleverapps/res/samsung/age_restriction.png";
        }

        cc.loader.loadImg(ageRestrictionSrc, (err, img) => {
            const ageRestriction = this.ageRestriction = new cc.Sprite(img);
            ageRestriction.setAnchorPoint(0.5, 0.5);
            this.addChild(ageRestriction);
            this.onResize();

            this.triggerShowAgeRestriction();
        });
    },

    triggerShowAgeRestriction: function () {
        if (this.visible && this.ageRestriction && this.onShowAgeRestriction) {
            this.onShowAgeRestriction();
            delete this.onShowAgeRestriction;
        }
    },

    addProgressBar: function () {
        const styles = cleverapps.styles.LoaderSceneBackground;
        const progressBar = this.progressBar = new ScaledProgressBar({
            progress: bundles[this.bundleId].frames.bar_loading,
            background: bundles[this.bundleId].frames.bg_loading
        });

        progressBar.setLocalZOrder(11);
        progressBar.setAnchorPoint(0.5, 0.5);
        this.addChild(progressBar);

        const topDecoratorFrame = bundles[this.bundleId].frames.top_decorator;

        if (topDecoratorFrame) {
            const topDecorator = new cc.Sprite(topDecoratorFrame);
            topDecorator.setAlignment(styles.topDecorator);
            progressBar.addChild(topDecorator);
        }

        this.addPointer();
        this.addProgressAnimation();

        const message = this.message = cleverapps.UI.generateOnlyText(LoaderScene.getLoadingText(this.slowLoading), cleverapps.styles.FONTS.LOADING_TEXT || cleverapps.styles.FONTS.TEXT);
        message.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        message.setLocalZOrder(11);
        message.setAnchorPoint(0.5, 0.5);
        this.addChild(message);

        if (this.percent) {
            this.setProgressBarPercentage(this.percent);
        }

        this.onResize();
    },

    addPointer: function () {
        const styles = cleverapps.styles.LoaderSceneBackground.pointer;

        const frame = bundles[this.bundleId].frames.pointer_loading;
        if (!frame) {
            return;
        }

        const progressBar = this.progressBar;
        const pointer = new cc.Sprite(frame);

        const updatePosition = pointer.createListener(() => {
            pointer.visible = progressBar.progress.width > 0;
            pointer.setPosition(progressBar.progress.width + styles.dx, progressBar.progress.height / 2 + styles.dy);
        });

        progressBar.onChangeListener = updatePosition;

        updatePosition();
        progressBar.addChild(pointer);
    },

    // keeps the bar alive while a file is retried, otherwise a full bar looks stuck
    addProgressAnimation: function () {
        this.progressBar.progress.runAction(new cc.RepeatForever(new cc.Sequence(
            new cc.Glare(0.9).easing(cc.easeInOut(2)),
            new cc.DelayTime(0.3)
        )));
    },

    showSlowLoading: function () {
        this.slowLoading = true;

        if (this.message) {
            this.message.setString(LoaderScene.getLoadingText(true));
            this.onResize();
        }
    },

    setProgressBarPercentage: function (percent) {
        this.percent = percent;

        if (this.progressBar) {
            this.progressBar.setPercentage(percent, {
                animated: true
            });
        }
    },

    addAnimations: function () {
        const logo = this.logo = new cleverapps.Spine(bundles.loading_scene.jsons.logo_json);

        const language = logo.hasAnimation(`animation_${cleverapps.settings.language}`)
            ? cleverapps.settings.language
            : cc.sys.LANGUAGE_ENGLISH;

        const source = logo.hasAnimation(`animation_${language}_${connector.info.source}`)
            ? `_${connector.info.source}`
            : "";

        logo.setAnchorPoint(0.5, 0.5);
        logo.setAnimationAndIdleAfter(`animation_${language}${source}`, `animation_${language}_idle${source}`);
        logo.setLocalZOrder(10);

        this.addChild(logo);

        if (bundles.loading_scene.jsons.bg_json) {
            const customAnimation = this.customAnimation = new cleverapps.Spine(bundles.loading_scene.jsons.bg_json);
            customAnimation.setAnchorPoint(0.5, 0.5);
            customAnimation.setAnimation(0, "animation", false);
            this.addChild(customAnimation);
        }
    },

    onResize: function () {
        const bgSize = cleverapps.resolution.getBgSize();
        this.setContentSize2(bgSize);

        if (!this.background) {
            return;
        }

        const background = this.background;

        const factorX = bgSize.width / background.width;
        const factorY = bgSize.height / background.height;
        const scale = Math.max(factorX, factorY);

        background.setScale(scale);
        background.setPosition(this.width / 2, this.height / 2);

        if (this.logo) {
            const slot = background.getSlot("slot_logo");

            cleverapps.UI.fitToBox(this.logo, {
                width: slot.width > 0 ? Math.min(slot.width * scale, bgSize.width) : bgSize.width,
                height: slot.height > 0 ? Math.min(slot.height * scale, bgSize.height) : bgSize.height
            });

            this.logo.setPosition(slot.x * factorX, slot.y * factorY);
        }

        if (this.progressBar) {
            const slot = background.getSlot("slot_loading_bar");
            this.progressBar.setLength(slot.width * factorX);
            this.progressBar.setPosition(slot.x * factorX, slot.y * factorY);

            if (this.message) {
                const slot = background.getSlot("slot_loading_bar_message");
                this.message.setPosition(slot.x * factorX, slot.y * factorY);
                // one line, wrapped text would cover the bar
                this.message.setDimensions(0, 0);
                this.message.fitTo(this.width * 0.9);
            }
        }

        if (this.customAnimation) {
            const slot = background.getSlot("slot_custom_animation");
            this.customAnimation.setPosition(slot.x * factorX, slot.y * factorY);
        }

        if (this.description) {
            const slot = background.getSlot("slot_description");
            this.description.setDimensions(slot.width * Math.min(1, factorX), 0);
            this.description.fitTo(undefined, slot.height * Math.min(1, factorY));
            this.description.setPosition(slot.x * factorX, slot.y * factorY);
        }

        if (this.ageRestriction) {
            const slot = background.getSlot("slot_age_restriction");
            cleverapps.UI.fitToBox(this.ageRestriction, {
                width: slot.width * factorX,
                height: slot.height * factorY
            });
            this.ageRestriction.setPosition(slot.x * factorX, slot.y * factorY);
        }
    }
});

LoaderSceneBackground.BACKGROUNDS = {};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LOADER_SCENE_DESCRIPTION: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            size: 4,
            color: new cc.Color(116, 49, 161, 200)
        }
    }
});

cleverapps.styles.LoaderSceneBackground = {
    pointer: { dx: -70, dy: 0 },

    topDecorator: {
        x: { align: "center" },
        y: { align: "top", dy: 47 }
    }
};